// 교육과정 숫자 id ↔ 영문 slug 매핑.
// SEO를 위해 대표 교육과정의 공개 URL을 영문 slug로 노출한다.
// (API/결제/수강 로직은 계속 숫자 id를 사용하므로, slug는 공개 상세 URL·내부 상세 링크·
//  canonical·sitemap 에서만 쓰고, 라우팅 진입 시 숫자 id로 해석한다.)
//
// 새 교육과정에 slug를 부여하려면 아래 두 객체에 한 쌍을 추가하면 된다.
// 주의: 이 파일은 generateSitemap.js(CommonJS)에서 직접 import할 수 없어,
//       동일 매핑이 public/generateSitemap.js 에도 인라인으로 존재한다. 함께 수정할 것.

export const COURSE_ID_TO_SLUG = {
  67: "sexual-offense-prevention", // 성범죄 재범방지교육
  35: "sentencing-guidelines", // 양형기준의 이해
  34: "drunk-driving-prevention", // 음주운전 재범방지교육
};

export const COURSE_SLUG_TO_ID = Object.entries(COURSE_ID_TO_SLUG).reduce(
  (acc, [id, slug]) => {
    acc[slug] = id;
    return acc;
  },
  {}
);

// URL 파라미터(slug 또는 숫자)를 API용 숫자 id 문자열로 해석한다.
export const resolveCourseId = (param) => COURSE_SLUG_TO_ID[param] ?? param;

// 숫자 id로 slug를 찾는다(없으면 undefined).
export const courseSlugById = (id) => COURSE_ID_TO_SLUG[String(id)] ?? undefined;

// 숫자 id에 매핑된 slug가 있으면 slug 경로를, 없으면 숫자 경로를 반환한다.
export const coursePathById = (id) => {
  const slug = COURSE_ID_TO_SLUG[String(id)];
  return `/courses/${slug ?? id}`;
};
